<template>

    <div id="placeholder">
        <div id="placeholder-text">
            <a href="https://soundtent.org/reveil.html">REVEIL 13</a>
            <span>2-3 May 2026</span>
        </div>
        <div id="placeholder-graphic-counter-container">
            <div id="placeholder-graphic">
                <img src="static/logo_2026_onwards.jpg">
                <img src="static/logo_2026_onwards_slow.gif">
            </div>
            <div id="placeholder-countdown"><span>{{days}}</span><span>{{hours}}</span><span>{{mins}}</span><span>{{secs}}</span></div>
        </div>
    </div>
</template>

<style>

    html, body {margin: 0; height: 100%; overflow: hidden}
    #app {
        margin-bottom:0 !important;
        height: auto !important;
    }
    #placeholder {
        position: relative;
        margin:36px;
    }
    #placeholder-graphic-counter-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: calc(100vh - 72px);
        flex-direction: column;
    }
    #placeholder-graphic {
        width: 30%;
        max-height: 50%;
        position:relative;
    }
    #placeholder-graphic img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    #placeholder-graphic img:first-child{
        position: absolute;
        top: 0;
        left: 0;
    }
    #placeholder-graphic img:first-child:hover {
        opacity: 0;
    }
    #placeholder-countdown {
        min-width:15%;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        height:0px;
        font-size: 30px;
        height: 30px;
        line-height:35px;
        margin-top:7vh;
    }
    #placeholder-text {
        position: absolute;
        top:0;
        left:0;
        display: flex;
        z-index: 10;
        width:100%;
        justify-content: space-between;
    }
     @media screen and (orientation:portrait) {
        #placeholder {
            margin:24px;
        }
        #placeholder-graphic{
            width:90%;
        }
        #placeholder-countdown {
            width:73.5%;
        }
     }
</style>



<script type="text/javascript">

    export default {
        data() {
            return {
                days: 0,
                hours: 0,
                mins: 0,
                secs: 0
            };
        },
        mounted() {
            var time = this;
            this.interval = setInterval(function(){time.updateCountdown();}, 1000);
            this.updateCountdown();

            window.addEventListener("resize", this.resetHeight);
            this.resetHeight();
        },
        destroyed() {
            clearInterval(this.interval);
             window.removeEventListener("resize", this.resetHeight);
        },
        methods: {
            resetHeight() {
                this.windowHeight = (window.innerHeight-72) + "px";
            },
            updateCountdown() {
                var reveilStart = new Date("2026-05-02T05:00:00.000+01:00");
                var now = new Date();
                var distance = reveilStart - now;

                var _second = 1000;
                var _minute = _second * 60;
                var _hour = _minute * 60;
                var _day = _hour * 24;

                this.days = Math.floor(distance / _day);
                this.hours = Math.floor((distance % _day) / _hour);
                this.mins = Math.floor((distance % _hour) / _minute);
                this.secs = Math.floor((distance % _minute) / _second);
            }
        }
    }




</script>


// WEBPACK FOOTER //
// src/components/Placeholder.vue